const doc = [({"zh_tw":({"adminConstantDayOfWeekShort":({"friday":"五", "monday":"一", "saturday":"六", "sunday":"日", "thursday":"四", "tuesday":"二", "wednesday":"三"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;